module.exports = __webpack_public_path__ + "media/driving_style_en_ipad_old.0bfed8ed.mp4";